// This file is generated by a script and should not be modified directly.
const markdown: string = "Allow filtering job offers by department numbers. This parameter accepts an array of department numbers\n"
export default markdown
